import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useAppNavigate = () => {
  const navigate = useNavigate();

  const goToHome = useCallback(() => {
    navigate("/home");
  }, [navigate]);

  const goToDashboard = useCallback(() => {
    navigate("/student/modules");
  }, [navigate]);

  const goToLogin = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const goToSignup = useCallback(() => {
    navigate("/signup");
  }, [navigate]);

  const goToForgotPassword = useCallback(() => {
    navigate("/forgot-password");
  }, [navigate]);

  const goToExercise = useCallback(
    (moduleId: string) => {
      navigate(`/student/exercises/${moduleId}`);
    },
    [navigate]
  );

  const goToPackageModules = useCallback(
    (packageId: string, packageInfo?: any) => {
      navigate(`/student/modules/${packageId}`, { 
        state: { packageId, packageInfo } 
      });
    },
    [navigate]
  );

  const goToCheckout = useCallback(
    (packageId: string, packageInfo?: any) => {
      navigate(`/student/checkout/${packageId}`, { 
        state: { packageId, packageInfo } 
      });
    },
    [navigate]
  );

  return {
    goToDashboard,
    goToLogin,
    goToSignup,
    goToForgotPassword,
    goToExercise,
    goToPackageModules,
    goToModule: goToPackageModules,
    goToCheckout,
    goToHome,
  };
};
